var ColorTokens = {
    DdsColorPaletteGrey3: "#00040f",
    DdsColorPaletteGrey10: "#14161f",
    DdsColorPaletteGrey20: "#2b2f3b",
    DdsColorPaletteGrey25: "#3a3c46",
    DdsColorPaletteGrey30: "#474a52",
    DdsColorPaletteGrey45: "#6e7079",
    DdsColorPaletteGrey50: "#797c86",
    DdsColorPaletteGrey60: "#95979e",
    DdsColorPaletteGrey75: "#bbbcc2",
    DdsColorPaletteGrey88: "#dedfe4",
    DdsColorPaletteGrey93: "#ebecef",
    DdsColorPaletteGrey98: "#f8f8fa",
    DdsColorPaletteGrey100: "#ffffff",
    DdsColorPaletteBlue10: "#090033",
    DdsColorPaletteBlue20: "#110165",
    DdsColorPaletteBlue30: "#1a0198",
    DdsColorPaletteBlue43: "#2401da",
    DdsColorPaletteBlue50: "#2a01fe",
    DdsColorPaletteBlue59: "#2f6aff",
    DdsColorPaletteBlue70: "#6692ff",
    DdsColorPaletteBlue80: "#99b6ff",
    DdsColorPaletteBlue90: "#ccdbff",
    DdsColorPaletteBlue95: "#e5edff",
    DdsColorPaletteGreen10: "#03301c",
    DdsColorPaletteGreen20: "#06603c",
    DdsColorPaletteGreen32: "#0a9959",
    DdsColorPaletteGreen43: "#0ecb76",
    DdsColorPaletteGreen50: "#0fe182",
    DdsColorPaletteGreen60: "#40f2a2",
    DdsColorPaletteGreen70: "#81f3c4",
    DdsColorPaletteGreen82: "#b1f1e2",
    DdsColorPaletteGreen90: "#cffce8",
    DdsColorPaletteGreen94: "#e2fdf1",
    DdsColorPaletteLime10: "#183300",
    DdsColorPaletteLime20: "#366501",
    DdsColorPaletteLime30: "#479801",
    DdsColorPaletteLime40: "#95cb01",
    DdsColorPaletteLime50: "#bffd11",
    DdsColorPaletteLime64: "#cdfe48",
    DdsColorPaletteLime73: "#dafe76",
    DdsColorPaletteLime80: "#e4fe9a",
    DdsColorPaletteLime90: "#ebffcc",
    DdsColorPaletteLime95: "#f5ffe5",
    DdsColorPaletteOrange10: "#2b0d08",
    DdsColorPaletteOrange20: "#561910",
    DdsColorPaletteOrange33: "#8e2a1a",
    DdsColorPaletteOrange38: "#c23200",
    DdsColorPaletteOrange50: "#ff4200",
    DdsColorPaletteOrange60: "#ff6631",
    DdsColorPaletteOrange70: "#ffb068",
    DdsColorPaletteOrange80: "#ffca99",
    DdsColorPaletteOrange90: "#ffe4cc",
    DdsColorPaletteOrange95: "#fff1e5",
    DdsColorPalettePink10: "#33001c",
    DdsColorPalettePink20: "#660039",
    DdsColorPalettePink33: "#a8005e",
    DdsColorPalettePink44: "#e0007d",
    DdsColorPalettePink55: "#ff1a99",
    DdsColorPalettePink66: "#ff54b3",
    DdsColorPalettePink70: "#ff66bb",
    DdsColorPalettePink80: "#ff99d2",
    DdsColorPalettePink90: "#ffcce8",
    DdsColorPalettePink95: "#ffe5fa",
    DdsColorPalettePurple10: "#190033",
    DdsColorPalettePurple20: "#330165",
    DdsColorPalettePurple30: "#4c0198",
    DdsColorPalettePurple40: "#6606c6",
    DdsColorPalettePurple50: "#8008f7",
    DdsColorPalettePurple60: "#a533ff",
    DdsColorPalettePurple75: "#c780ff",
    DdsColorPalettePurple80: "#d299ff",
    DdsColorPalettePurple90: "#e9ccff",
    DdsColorPalettePurple95: "#f4e5ff",
    DdsColorPaletteRed10: "#330000",
    DdsColorPaletteRed20: "#660000",
    DdsColorPaletteRed33: "#a80000",
    DdsColorPaletteRed43: "#db0000",
    DdsColorPaletteRed50: "#ff0000",
    DdsColorPaletteRed60: "#ff3333",
    DdsColorPaletteRed75: "#ff8282",
    DdsColorPaletteRed86: "#ffb8b8",
    DdsColorPaletteRed90: "#ffcccc",
    DdsColorPaletteRed95: "#ffe5e6",
    DdsColorPaletteTeal10: "#002833",
    DdsColorPaletteTeal20: "#005166",
    DdsColorPaletteTeal30: "#007999",
    DdsColorPaletteTeal40: "#099fc3",
    DdsColorPaletteTeal49: "#00ebfa",
    DdsColorPaletteTeal60: "#33daff",
    DdsColorPaletteTeal70: "#6dddf8",
    DdsColorPaletteTeal80: "#9ee9fa",
    DdsColorPaletteTeal90: "#cef4fd",
    DdsColorPaletteTeal95: "#e7f9fe",
    DdsColorPaletteYellow10: "#331c00",
    DdsColorPaletteYellow20: "#663800",
    DdsColorPaletteYellow33: "#a85d00",
    DdsColorPaletteYellow44: "#e0a500",
    DdsColorPaletteYellow50: "#ffbb00",
    DdsColorPaletteYellow66: "#ffe552",
    DdsColorPaletteYellow75: "#ffec80",
    DdsColorPaletteYellow80: "#fff099",
    DdsColorPaletteYellow90: "#fff7cc",
    DdsColorPaletteYellow95: "#fffbe5",
    DdsColorPaletteBlack: "#00040f",
    DdsColorPaletteWhite: "#ffffff",
    DdsColorTextPrimaryOndefault: "#00040f",
    DdsColorTextPrimaryOninverse: "#ffffff",
    DdsColorTextDiminishedOndefault: "#797c86",
    DdsColorTextDiminishedOninverse: "#bbbcc2",
    DdsColorTextDisabledOndefault: "#bbbcc2",
    DdsColorTextLinkDefault: "#6606c6",
    DdsColorTextLinkHover: "#330165",
    DdsColorTextLinkActive: "#4c0198",
    DdsColorTextLinkDisabled: "#d299ff",
    DdsColorTextInvalidOndefault: "#a80000",
    DdsColorTextDangerDefault: "#a80000",
    DdsColorTextDangerHover: "#660000",
    DdsColorTextDangerActive: "#330000",
    DdsColorTextDangerDisabled: "#ffb8b8",
    DdsColorTextWarningDefault: "#a85d00",
    DdsColorBorderControlDefault: "#bbbcc2",
    DdsColorBorderControlHover: "#95979e",
    DdsColorBorderControlActive: "#797c86",
    DdsColorBorderControlDisabled: "#dedfe4",
    DdsColorBorderControlInvalid: "#a80000",
    DdsColorBorderDividerDefault: "#dedfe4",
    DdsColorBorderDividerDark: "#6e7079",
    DdsColorBorderContainerDefault: "#dedfe4",
    DdsColorBorderNotificationCaution: "#ffbb00",
    DdsColorBorderNotificationError: "#a80000",
    DdsColorBorderNotificationHighlight: "#bffd11",
    DdsColorBorderNotificationNote: "#007999",
    DdsColorBorderNotificationSuccess: "#06603c",
    DdsColorBorderAdmin: "#ff8282",
    DdsColorInteractivePrimaryDefault: "#8008f7",
    DdsColorInteractivePrimaryHover: "#6606c6",
    DdsColorInteractivePrimaryActive: "#4c0198",
    DdsColorInteractivePrimaryDisabled: "#e9ccff",
    DdsColorInteractiveSecondaryDefault: "#ffffff",
    DdsColorInteractiveSecondaryHover: "#f8f8fa",
    DdsColorInteractiveSecondaryActive: "#ebecef",
    DdsColorInteractiveSecondaryDisabled: "#f8f8fa",
    DdsColorInteractiveDangerDefault: "#db0000",
    DdsColorInteractiveDangerHover: "#a80000",
    DdsColorInteractiveDangerActive: "#660000",
    DdsColorInteractiveDangerDisabled: "#ffb8b8",
    DdsColorInteractiveFocusringInner: "#ffffff",
    DdsColorInteractiveFocusringOuter: "#00040f",
    DdsColorRequiredindicator: "#a80000",
    DdsColorBackgroundDefault: "#ffffff",
    DdsColorBackgroundAlternative: "#f8f8fa",
    DdsColorBackgroundInverse: "#14161f",
    DdsColorBackgroundNotificationDanger: "#ffe5e6",
    DdsColorBackgroundNotificationError: "#ffe5e6",
    DdsColorBackgroundNotificationSuccess: "#e2fdf1",
    DdsColorBackgroundNotificationCaution: "#fff7cc",
    DdsColorBackgroundNotificationNeutral: "#f8f8fa",
    DdsColorBackgroundNotificationNote: "#e7f9fe",
    DdsColorBackgroundAdmin: "#ff8282",
    DdsColorBackgroundHighlight: "#dafe76",
    DdsColorIconDefault: "#00040f",
    DdsColorIconDiminished: "#797c86",
    DdsColorIconDanger: "#db0000",
    DdsColorIconDisabled: "#95979e",
    DdsColorIconSuccess: "#0a9959",
    DdsColorIconCaution: "#ff6631",
    DdsColorIconWarning: "#ffbb00",
    DdsColorIconNote: "#099fc3",
    DdsColorIconAdmin: "#ff8282",
    DdsColorFillNotificationError: "#db0000",
    DdsColorFillNotificationSuccess: "#0a9959",
    DdsColorFillNotificationCaution: "#ffbb00",
    DdsColorFillNotificationNote: "#099fc3",
    DdsColorFillNotificationHighlight: "#bffd11"
};
export default ColorTokens;

